import { useCallback, useEffect, useState } from 'react';
import {
  fetchActiveReservations,
  type ActiveReservation,
} from '@/services/inventory';

// Carga el desglose de reservas activas (stock retenido por pedidos pendientes).
// Es informativo y no bloqueante: si falla, deja la lista vacía.
export function useActiveReservations() {
  const [reservations, setReservations] = useState<ActiveReservation[]>([]);
  const [totalUnits, setTotalUnits] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    fetchActiveReservations()
      .then((res) => {
        if (cancelled) return;
        setReservations(res.reservations);
        setTotalUnits(res.totalUnits);
      })
      .catch(() => {
        if (cancelled) return;
        setReservations([]);
        setTotalUnits(0);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => load(), [load]);

  return { reservations, totalUnits, loading, refetch: load };
}